import { useState } from 'react'

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState<'users' | 'notifications' | 'stats'>('users')

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-900">Administration</h1>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <div className="flex gap-8">
          {[
            { id: 'users', label: 'Users', icon: '👥' },
            { id: 'notifications', label: 'Notifications', icon: '📧' },
            { id: 'stats', label: 'Statistics', icon: '📊' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id as typeof activeTab)}
              className={`px-4 py-4 border-b-2 font-medium transition ${
                activeTab === tab.id
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Users Tab */}
      {activeTab === 'users' && (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">User Management</h2>
          <div className="text-gray-600 py-8 text-center">
            <p>User management interface coming soon</p>
          </div>
        </div>
      )}

      {/* Notifications Tab */}
      {activeTab === 'notifications' && (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Notification Log</h2>
          <div className="text-gray-600 py-8 text-center">
            <p>Notification log interface coming soon</p>
          </div>
        </div>
      )}

      {/* Statistics Tab */}
      {activeTab === 'stats' && (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">System Statistics</h2>
          <div className="grid grid-cols-3 gap-6">
            <div className="text-center p-4 border border-gray-200 rounded">
              <p className="text-3xl font-bold text-purple-600">0</p>
              <p className="text-sm text-gray-600 mt-2">Active Projects</p>
            </div>
            <div className="text-center p-4 border border-gray-200 rounded">
              <p className="text-3xl font-bold text-blue-600">0</p>
              <p className="text-sm text-gray-600 mt-2">Active Users</p>
            </div>
            <div className="text-center p-4 border border-gray-200 rounded">
              <p className="text-3xl font-bold text-green-600">0</p>
              <p className="text-sm text-gray-600 mt-2">Tasks Completed</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
